import { createRouter, createWebHashHistory } from 'vue-router'
import Home from '../views/Home.vue'

const routes = [
  {
    path: '/',
    name: 'Logo',
    component: () => import( '../views/Logo.vue')
  },
  {
    path: '/home',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/themes',
    name: 'Themes',
    component: () => import( '../views/Themes.vue')
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import( '../views/Contact.vue')
  },
  {
    path: '/admin',
    name: 'AdminCountries',
    component: () => import('../views/AdminCountries.vue')
  },
  {
    path: '/admin-themes',
    name: 'AdminThemes',
    component: () => import('../views/AdminThemes.vue')
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
